var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HomePage"},[_c('GHeader',{ref:"header",attrs:{"title":"Understanding transform:matrix()","headerLinks":[
      {
        title: 'Code',
        items: [
          {
            title: 'GitHub',
            href: 'https://github.com/ginpei/understanding-transform-matrix',
          } ],
      } ]}}),_c('SvgGraph',{attrs:{"width":_vm.graphWidth,"height":_vm.graphHeight,"positionTop":_vm.graphTop,"matrix":_vm.mergedMatrix,"onMove":_vm.graph_onMove,"onEnd":_vm.graph_onEnd,"onOriginMove":_vm.graph_onOriginMove,"onOriginMoveEnd":_vm.graph_onOriginMoveEnd,"posOrigin":_vm.mergedOrigin,"pointIndicatorVisible":_vm.pointIndicatorVisible}}),_c('div',{staticClass:"HomePage-controlPanel"},[_c('HomeFloatingPanel',{attrs:{"curTab":_vm.curTab,"matrix":_vm.mergedMatrix,"onTabChange":_vm.floatingPanel_onTabChange,"onPreset":_vm.floatingPanel_onPreset}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }